import InputDate from "components/atoms/InputDate";
import InputRadio from "components/atoms/InputRadio";
import InputSelect from "components/atoms/InputSelect";
import { BreadcrumbNav } from "components/molecules";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { ArrowDown, ArrowUp } from "react-feather";
import { useSelector } from "react-redux";
import { generateMonthOptions } from "utils/common";
import { MonthOptions, Source, UserLevel } from "utils/constant";
import Wilayah from "services/Wilayah";
import Fasyankes from "services/Fasyankes";
import Laporan from "services/Laporan";
import Button from "components/atoms/Button";
import { HashLoader } from "react-spinners";
import TableComponent from "./Table";
import { exportToExcel } from "utils/exportExcel";
import { useHistory } from "react-router-dom";
import Pagination from "components/Pagination";
import DataDasarPenduduk from "services/Populasi";

const WilayahService = new Wilayah();
const FasyankesService = new Fasyankes();
const LaporanService = new Laporan();
const DataDasarPendudukService = new DataDasarPenduduk();

const DetailLaporan = () => {
  const module = "Regmal 1 Desa Domisili";

  const { currentUser } = useSelector((state) => state.authReducer);
  const [isDownloading, setIsDownloading] = useState(false);
  const tableRef = useRef(null);
  const history = useHistory();

  const [reportData, setReportData] = useState([]);
  const [showFilter, setShowFilter] = useState(true);
  const [showData, setShowData] = useState(false);
  const [levelData, setLevelData] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState(currentUser.level);
  const [currentLevel, setCurrentLevel] = useState("");
  const [levelIdValue, setLevelIdValue] = useState("");
  const [levelDataOptions, setLevelDataOptions] = useState({
    provinces: [],
    districts: [],
    fasyankes: [],
    urbanvillage: [],
  });
  const [selectedProvince, setSelectedProvince] = useState(
    currentUser?.province_id
  );
  const [selectedDistrict, setSelectedDistrict] = useState(
    currentUser?.district_id
  );
  const [selectedFasyankes, setSelectedFasyankes] = useState(
    currentUser?.fasyankes_id
  );
  const [selectedUrbanVillage, setSelectedUrbanVillage] = useState(
    currentUser?.urbanvillage_id
  );
  const [periodeLaporan, setPeriodeLaporan] = useState("");
  const [periodeLaporanValue, setPeriodeLaporanValue] = useState("");
  const [selectedEnd, setSelectedEnd] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [reportInfo, setReportInfo] = useState({});

  const isPeriodeValid =
    periodeLaporanValue &&
    ((periodeLaporan === "monthly" &&
      Object.keys(periodeLaporanValue).length > 1) ||
      (periodeLaporan === "yearly" &&
        Object.keys(periodeLaporanValue).length > 0));

  const isLevelValid =
    (selectedLevel === UserLevel.Fasyankes &&
      !!selectedFasyankes &&
      !!selectedUrbanVillage) ||
    (selectedLevel === UserLevel.District && !!selectedDistrict) ||
    (selectedLevel === UserLevel.Province && !!selectedProvince) ||
    selectedLevel === UserLevel.National;

  const isEnableButton = isPeriodeValid && isLevelValid;

  const fetchAllProvincies = async () => {
    try {
      const response = await WilayahService.getAll(Source.PROVINCE, {
        page: 1,
        limit: 9999,
      });
      setLevelDataOptions((prevState) => ({
        ...prevState,
        provinces: response.province.map((item) => {
          return {
            label: item.name,
            value: `${item.id}|${item.name}`,
          };
        }),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDistrictByProvince = async (provinceId) => {
    try {
      const response = await WilayahService.getAll(Source.DISTRICT, {
        page: 1,
        limit: 9999,
        searchBy: "province_id",
        searchValue: provinceId,
      });

      setLevelDataOptions((prevState) => ({
        ...prevState,
        districts: response.district.map((item) => {
          return {
            label: item.name,
            value: `${item.id}|${item.name}`,
          };
        }),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchFasyankesByDistrict = async (districtId) => {
    try {
      const response = await FasyankesService.getAll(Source.FASYANKES, {
        page: 1,
        limit: 9999,
        searchBy: "district_id",
        searchValue: districtId,
      });

      setLevelDataOptions((prevState) => ({
        ...prevState,
        fasyankes: response.fasyankes.map((item) => {
          return {
            label: item.name,
            value: `${item.id}|${item.name}`,
          };
        }),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchUrbanvillageByFasyankes = async (fasyankesId, year) => {
    try {
      const response = await DataDasarPendudukService.getAll({
        page: 1,
        limit: 9999,
        searchBy: `fasyankes_id,year`,
        searchValue: `${fasyankesId},${year ? year : periodeLaporanValue.year}`,
      });

      const data = response.populations.map((item) => ({
        label: item.urbanvillage_id?.split("|")[1],
        value: item.urbanvillage_id,
      }));

      setLevelDataOptions((prevState) => ({
        ...prevState,
        urbanvillage: data,
      }));
    } catch (err) {
      console.error(err);
    }
  };

  const generateLevelOptions = (userLevel) => {
    switch (userLevel) {
      case UserLevel.Fasyankes:
        return [{ label: "Fasyankes", value: UserLevel.Fasyankes }];
      case UserLevel.District:
        return [
          { label: "Kabupaten/Kota", value: UserLevel.District },
          { label: "Fasyankes", value: UserLevel.Fasyankes },
        ];
      case UserLevel.Province:
        return [
          { label: "Provinsi", value: UserLevel.Province },
          { label: "Kabupaten/Kota", value: UserLevel.District },
          { label: "Fasyankes", value: UserLevel.Fasyankes },
        ];
      default:
        return [
          { label: "Nasional", value: UserLevel.National },
          { label: "Provinsi", value: UserLevel.Province },
          { label: "Kabupaten/Kota", value: UserLevel.District },
          { label: "Fasyankes", value: UserLevel.Fasyankes },
        ];
    }
  };

  useEffect(() => {
    if (currentUser.level === UserLevel.District) {
      setSelectedFasyankes("");
      setSelectedUrbanVillage("");
    } else if (currentUser.level === UserLevel.Province) {
      setSelectedDistrict("");
      setSelectedFasyankes("");
      setSelectedUrbanVillage("");
    } else if (currentUser.level === UserLevel.National) {
      setSelectedProvince("");
      setSelectedDistrict("");
      setSelectedFasyankes("");
      setSelectedUrbanVillage("");
    }
  }, [selectedLevel]);

  useEffect(() => {
    if (currentUser.level === UserLevel.Fasyankes) {
      setLevelIdValue(currentUser?.fasyankes_id);
    } else if (currentUser.level === UserLevel.District) {
      setLevelIdValue(currentUser?.district_id);
    } else if (currentUser.level === UserLevel.Province) {
      setLevelIdValue(currentUser?.province_id);
    } else {
      setLevelIdValue("");
    }
  }, [selectedLevel]);

  useEffect(() => {
    fetchAllProvincies();

    if (selectedProvince) {
      fetchDistrictByProvince(selectedProvince?.split("|")[0]);
    }
    if (selectedDistrict) {
      fetchFasyankesByDistrict(selectedDistrict?.split("|")[0]);
    }
    if (selectedFasyankes) {
      fetchUrbanvillageByFasyankes(selectedFasyankes);
    }
  }, [selectedProvince, selectedDistrict, selectedFasyankes]);

  useEffect(() => {
    const levelOptions = generateLevelOptions(currentUser?.level);
    setLevelData(levelOptions);
  }, [currentUser]);

  // periode laporan inputan
  const renderPeriodeFilter = () => {
    switch (periodeLaporan) {
      case "yearly":
        return (
          <InputDate
            value={periodeLaporanValue}
            onChange={(e) => {
              const selectedYear = moment(e).format("YYYY");
              setPeriodeLaporanValue({ year: selectedYear });
              if (selectedFasyankes) {
                fetchUrbanvillageByFasyankes(selectedFasyankes, selectedYear);
                setSelectedUrbanVillage("");
              }
            }}
            placeholder={"Pilih Tahun"}
            dateFormat={"YYYY"}
          />
        );
      case "monthly":
        return (
          <div style={{ display: "flex", flexDirection: "row", gap: "1.2rem" }}>
            <div style={{ flex: "1" }}>
              <InputDate
                value={periodeLaporanValue}
                onChange={(e) => {
                  const selectedYear = moment(e).format("YYYY");
                  setPeriodeLaporanValue((prevPeriode) => ({
                    ...prevPeriode,
                    year: selectedYear,
                  }));
                  if (selectedFasyankes) {
                    fetchUrbanvillageByFasyankes(
                      selectedFasyankes,
                      selectedYear
                    );
                    setSelectedUrbanVillage("");
                  }
                }}
                placeholder={"Pilih Tahun"}
                dateFormat={"YYYY"}
              />
            </div>
            <div style={{ flex: "1" }}>
              <InputSelect
                data={MonthOptions}
                isClearable={false}
                placeholder={"Bulan Mulai"}
                value={MonthOptions.find((e) => e.value === periodeLaporanValue.month_start) ?? ""}
                onChange={(e) => {
                  setPeriodeLaporanValue((prevPeriode) => {
                    const { month_end, ...rest } = prevPeriode;
                    return { ...rest, month_start: e.value };
                  });
                  setSelectedEnd("");
                  if (selectedFasyankes) {
                    fetchUrbanvillageByFasyankes(selectedFasyankes);
                    setSelectedUrbanVillage("");
                  }
                }}
              />
            </div>
            <div style={{ flex: "1" }}>
              <InputSelect
                data={generateMonthOptions(periodeLaporanValue.month_start)}
                isClearable={false}
                placeholder={"Bulan Akhir"}
                onChange={(e) => {
                  setPeriodeLaporanValue((prevPeriode) => ({
                    ...prevPeriode,
                    month_end: e.value,
                  }));
                  setSelectedEnd(e.value);
                  if (selectedFasyankes) {
                    fetchUrbanvillageByFasyankes(selectedFasyankes);
                    setSelectedUrbanVillage("");
                  }
                }}
                value={generateMonthOptions(periodeLaporanValue.month_start)?.find((item) => item.value === selectedEnd) || ""}
              />
            </div>
          </div>
        );
    }
  };

  // level options
  const renderLevelFilter = () => {
    switch (selectedLevel) {
      case UserLevel.Province:
        return (
          <div style={{ display: "flex", flexDirection: "row", gap: "1.2rem" }}>
            <div style={{ flex: "1" }}>
              <InputSelect
                isClearable={false}
                placeholder={"Pilih Provinsi"}
                data={levelDataOptions.provinces}
                onChange={(e) => {
                  setSelectedProvince(e.value);
                  setLevelIdValue(e.value);
                }}
                value={
                  levelDataOptions.provinces?.find(
                    (item) => item.value === selectedProvince
                  ) || ""
                }
                isDisabled={
                  currentUser.level === UserLevel.National ? false : true
                }
              />
            </div>
          </div>
        );
      case UserLevel.District:
        return (
          <div className="row">
            <div className="col-sm-6 mb-3">
              <InputSelect
                isClearable={false}
                placeholder={"Pilih Provinsi"}
                data={levelDataOptions.provinces}
                onChange={(e) => {
                  setSelectedProvince(e.value);
                  setSelectedDistrict("");
                }}
                value={
                  levelDataOptions.provinces?.find(
                    (item) => item.value === selectedProvince
                  ) || ""
                }
                isDisabled={
                  currentUser.level === UserLevel.National ? false : true
                }
              />
            </div>
            <div className="col-sm-6 mb-3">
              <InputSelect
                isClearable={false}
                placeholder={"Pilih Kab/Kota"}
                data={
                  currentUser?.level === UserLevel.District
                    ? levelDataOptions.districts?.filter(
                        (item) => item.value === currentUser?.district_id
                      )
                    : levelDataOptions.districts
                }
                onChange={(e) => {
                  setSelectedDistrict(e.value);
                  setLevelIdValue(e.value);
                }}
                value={
                  levelDataOptions.districts?.find(
                    (item) => item.value === selectedDistrict
                  ) || ""
                }
                isDisabled={
                  currentUser.level === UserLevel.National ||
                  currentUser.level === UserLevel.Province
                    ? false
                    : true
                }
              />
            </div>
          </div>
        );
      case UserLevel.Fasyankes:
        return (
          <div className="col">
            {/* Baris 1 */}
            <div className="row">
              <div className="col-sm-6 mb-3">
                <InputSelect
                  isClearable={false}
                  placeholder={"Pilih Provinsi"}
                  data={levelDataOptions.provinces}
                  onChange={(e) => {
                    setSelectedProvince(e.value);
                    setSelectedFasyankes("");
                    setSelectedUrbanVillage("");
                    setSelectedDistrict("");
                  }}
                  value={
                    levelDataOptions.provinces?.find(
                      (item) => item.value === selectedProvince
                    ) || ""
                  }
                  isDisabled={
                    currentUser?.level === UserLevel.National ? false : true
                  }
                />
              </div>
              <div className="col-sm-6 mb-3">
                <InputSelect
                  isClearable={false}
                  placeholder={"Pilih Kab/Kota"}
                  data={levelDataOptions.districts}
                  onChange={(e) => {
                    setSelectedDistrict(e.value);
                    setSelectedFasyankes("");
                    setSelectedUrbanVillage("");
                  }}
                  value={
                    levelDataOptions.districts?.find(
                      (item) => item.value === selectedDistrict
                    ) || ""
                  }
                  isDisabled={
                    (currentUser?.level === UserLevel.National &&
                      selectedProvince !== "") ||
                    (currentUser?.level === UserLevel.Province &&
                      selectedProvince !== "")
                      ? false
                      : true
                  }
                />
              </div>
            </div>
            {/* Baris 2 */}
            <div className="row">
              <div className="col-sm-6 mb-3">
                <InputSelect
                  isClearable={false}
                  isMultipleSelect={false}
                  placeholder={"Pilih Fasyankes"}
                  data={
                    currentUser.level === UserLevel.Fasyankes
                      ? levelDataOptions.fasyankes?.filter(
                          (item) => item.value === currentUser?.fasyankes_id
                        )
                      : levelDataOptions.fasyankes
                  }
                  onChange={(e) => {
                    setSelectedFasyankes(e.value);
                    setLevelIdValue(e.value);
                    setSelectedUrbanVillage("");
                  }}
                  value={levelDataOptions.fasyankes?.filter((item) =>
                    selectedFasyankes?.includes(item.value)
                  )}
                  isDisabled={
                    (currentUser?.level === UserLevel.National &&
                      selectedDistrict !== "") ||
                    (currentUser?.level === UserLevel.Province &&
                      selectedDistrict !== "") ||
                    (currentUser?.level === UserLevel.District &&
                      selectedDistrict !== "")
                      ? false
                      : true
                  }
                />
              </div>
              <div className="col-sm-6 mb-3">
                <InputSelect
                  isClearable={false}
                  isMultipleSelect={true}
                  placeholder={"Pilih Desa"}
                  data={levelDataOptions.urbanvillage}
                  onChange={(e) => {
                    let value = e.map(function (item) {
                      return item.value;
                    });
                    let resultValue = value.join(",");
                    setSelectedUrbanVillage(resultValue);
                  }}
                  value={levelDataOptions.urbanvillage?.filter((item) =>
                    selectedUrbanVillage?.includes(item.value)
                  )}
                  isDisabled={selectedFasyankes === ""}
                />
              </div>
            </div>
          </div>
        );
    }
  };

  const handleApplyFilter = async ({ isExport = false, page }) => {
    const params = {
      level: selectedLevel.toLowerCase(),
      level_id: levelIdValue,
      period: periodeLaporan,
      ...periodeLaporanValue,
      page: page ?? 1,
      urbanvillage: selectedUrbanVillage,
      is_domicile_urbanvillage: true,
    };
    try {
      if (isExport) {
        setIsDownloading(true);
        await LaporanService.Regmal1DomicileVillageExcel(params)
          .then((excelData) => {
            const url = window.URL.createObjectURL(new Blob([excelData]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `LAPORAN_REGMAL_1_DESA_DOMISILI_${
                params.level == "national"
                  ? "Nasional"
                  : params.level_id?.split("|")[1]
              }_${moment().format("DDMMYYYY")}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            setIsDownloading(false);
          })
          .catch((err) => {
            console.log(err);
            setIsDownloading(false);
          });
        return;
      } else {
        setIsLoading(true);
        setShowData(false);
        const response = await LaporanService.Regmal1DomicileVillage(params);
        setReportInfo({
          statusPeriode: periodeLaporan,
          periode: periodeLaporanValue,
          province: selectedProvince,
          district: selectedDistrict,
          fasyankes: selectedFasyankes,
          urbanvillage: selectedUrbanVillage,
        });
        setReportData(response);
        setCurrentLevel(params.level);
      }
    } catch (error) {
      console.log(error);
      setReportData([]);
    } finally {
      setIsLoading(false);
      if (!isExport) setShowData(true);
    }
  };

  return (
    <div className="dashboard-wrapper">
      <BreadcrumbNav
        items={[
          { label: "Laporan", onClick: () => history.push("/laporan") },
          { label: module },
        ]}
      />
      <div className="filter">
        <div className="filter-header">
          <p>FILTER</p>
          <button
            className="btn_toggle_filter"
            onClick={() => setShowFilter(!showFilter)}
          >
            {showFilter ? <ArrowUp size={18} /> : <ArrowDown size={18} />}
          </button>
        </div>
        {showFilter && (
          <div className="filter-body">
            <div className="filter-item">
              <div className="filter-label">
                <p>Periode Laporan</p>
              </div>
              <div className="filter-field">
                <InputRadio
                  name="periode_laporan"
                  isRequired={true}
                  options={[
                    { label: "Tahunan", value: "yearly" },
                    { label: "Bulanan", value: "monthly" },
                  ]}
                  onChange={(e) => {
                    setPeriodeLaporan(e.target.value);
                    setPeriodeLaporanValue("");
                    setSelectedEnd("");
                  }}
                  selectedOption={periodeLaporan}
                />
                <div className="advanced-filter">{renderPeriodeFilter()}</div>
              </div>
            </div>
            <div className="filter-item">
              <div className="filter-label">
                <p>Level</p>
              </div>
              <div className="filter-field">
                <InputRadio
                  options={levelData}
                  onChange={(e) => {
                    setSelectedLevel(e.target.value);

                    if (e.target.value != currentUser.level) {
                      setLevelIdValue("");
                    } else {
                      if (currentUser.level === UserLevel.Fasyankes) {
                        setLevelIdValue(currentUser?.fasyankes_id);
                      } else if (currentUser.level === UserLevel.District) {
                        setLevelIdValue(currentUser?.district_id);
                      } else if (currentUser.level === UserLevel.Province) {
                        setLevelIdValue(currentUser?.province_id);
                      } else {
                        setLevelIdValue("");
                      }
                    }
                  }}
                  selectedOption={selectedLevel}
                />
                <div className="advanced-filter">{renderLevelFilter()}</div>
              </div>
            </div>
            <div className="filter-item">
              <div className="filter-field">
                <div className="filter-condition">
                  <Button
                    variant={"primary"}
                    size={"normal"}
                    onClick={() => handleApplyFilter({ isExport: false })}
                    isDisabled={!isEnableButton}
                  >
                    Terapkan
                  </Button>
                  <Button
                    variant={"secondary"}
                    size={"normal"}
                    onClick={() => handleApplyFilter({ isExport: true })}
                    isDisabled={isDownloading}
                  >
                    Export Excel
                    {isDownloading ? "..." : ""}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* loading spinner */}
      {isLoading && !showData && (
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            marginTop: "5rem",
          }}
        >
          <HashLoader size={100} color="#18b3ab" />
        </div>
      )}

      {showData && (
        <div className="table-container">
          <div className="data-title">
            <h2>{module}</h2>
          </div>
          <div className="data-main">
            {reportData && (
              <TableComponent
                currentLevel={currentLevel}
                reportsData={reportData.regmals}
                tableRef={tableRef}
                reportInfo={reportInfo}
                paginationData={{
                  total: reportData?.total,
                  limit: reportData?.limit,
                  nextPage: reportData?.nextPage,
                  currentPage: reportData?.currentPage,
                }}
              />
            )}
            {reportData && (
              <Pagination
                style={{ marginTop: "1rem" }}
                totalRecords={reportData?.total}
                pageLimit={reportData?.limit}
                currentPage={reportData?.currentPage}
                onPageChange={(page) => {
                  handleApplyFilter({
                    page: page,
                    isExport: false,
                  });
                }}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailLaporan;
